"use strict";
/**
 * @file Option & OptionGroup
 * @desc 对外的 Option & OptionGroup 组件定义
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionGroup = exports.Option = void 0;
function Option(_a) {
    var value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b, children = _a.children;
    return null;
}
exports.Option = Option;
function OptionGroup(props) {
    return null;
}
exports.OptionGroup = OptionGroup;
//# sourceMappingURL=Option.js.map